import { createContext, useContext } from 'react';
import type { SortOrder } from '../../common/types.tsx';

type SortChangeContext = {
	onSortChange?: (field: string, direction: SortOrder, aliases?: string[]) => void;
};

const SortChangeContext = createContext<SortChangeContext | undefined>({});

export const SortChangeContextProvider = SortChangeContext.Provider;

export const useSortContext = () => {
	const context = useContext(SortChangeContext);
	return context !== undefined ? context : {};
};
